var React = require('react');

function ArrowRightInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4.613,90.001l59.543,-45.018","style":{"fill":"none","fillRule":"nonzero","stroke":"#fff","strokeWidth":"1.56px"},"key":0}),React.createElement("path",{"d":"M4.613,0l59.543,45.019","style":{"fill":"none","fillRule":"nonzero","stroke":"#fff","strokeWidth":"1.56px"},"key":1})]);
}

ArrowRightInline.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 69 91","version":"1.1","xmlSpace":"preserve","xmlnsSerif":"http://www.serif.com/","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeMiterlimit":"10"}};

module.exports = ArrowRightInline;

ArrowRightInline.default = ArrowRightInline;
